import Table from "../../components/Table";
import Layout from "../../components/Layout";

export default function AccountApiKey() {
  return (
    <Layout metaTitle="Account API Keys">
      <Table
        url="/d/apikeys/account_apikey/"
        formURL="/d/apikeys/account_apikey/form/"
        tableName="Account API Key"
        tableDescription="Account keys are mainly to authenticate account-level requests such as Transactions, Intents, or other account-owned entities."
      />
    </Layout>
  );
}

AccountApiKey.parentPath = "/account-api-key";
